import {
  GET_LIST_QUANLYCONGVIEC,
  GET_LIST_QUANLYCONGVIEC_SUCCESS,
  GET_LIST_QUANLYCONGVIEC_FAILURE,
} from "./actionTypes";

export const getListQuanLyCongViec = (dataSearch) => ({
  type: GET_LIST_QUANLYCONGVIEC,
  dataSearch,
});

export const getListQuanLyCongViecSuccess = (data) => ({
  type: GET_LIST_QUANLYCONGVIEC_SUCCESS,
  payload: data,
});

export const getListQuanLyCongViecFailure = () => ({
  type: GET_LIST_QUANLYCONGVIEC_FAILURE,
});
